import axios from "axios";

import config from "../config";
import {encodeQueryData} from "./utils";

const ENDPOINT = config.apiEndpoint;

const createOne = (item) => {
  const url = `${ENDPOINT}/auth/variantMetafieldSearchFields`;
  return axios({
    url,
    data: item,
    method: "post",
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  })
};

const getAll = (params) => {
  const url = `${ENDPOINT}/auth/variantMetafieldSearchFields?${encodeQueryData(params)}`;
  return axios({
    url,
    method: "get",
    withCredentials: true,
  })
};

const updateOne = (item) => {
  const url = `${ENDPOINT}/auth/variantMetafieldSearchFields/${item.id}`;
  const {
    namespace, key, isValueTypeMetaobject, metaobjectFieldKey, valueDataType, delimiter, weight, searchForProducts, buildSearchSuggestion, enable
  } = item;
  return axios({
    url,
    method: "put",
    data: {
      namespace,
      key,
      valueDataType,
      isValueTypeMetaobject,
      metaobjectFieldKey,
      delimiter,
      weight,
      searchForProducts,
      buildSearchSuggestion,
      enable,
    },
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  })
};

const deleteOne = (itemId) => {
  const url = `${ENDPOINT}/auth/variantMetafieldSearchFields/${itemId}`;
  return axios({
    url,
    method: 'delete',
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  })
};

const variantMetafieldSearchFieldAPI = {
  createOne,
  getAll,
  updateOne,
  deleteOne,
};

export default variantMetafieldSearchFieldAPI;
